import React from "react";
import { Stack } from "@mui/material";

import icon from "../../../styles/svg/critical_priority.svg";
import { useAllocationGroupingState } from "../hooks/useAllocationGroupingState";
import Header from "./components/Header";
import GroupingBoards from "./components/GroupingBoards";

const AllocationGrouping = React.memo(() => {
  const { hasAssignedTeam, teams, teamIsLoading, groupingUserFromRedux } =
    useAllocationGroupingState();

  // if (!hasAssignedTeam) {
  //   return (
  //     <Stack height={"80vh"} justifyContent={"center"} alignItems={"center"}>
  //       <div style={{ padding: "20px", textAlign: "center" }}>
  //         <img src={icon} alt="error" style={{ height: "140px" }} />
  //         <h2>You have not been assigned to any team.</h2>
  //       </div>
  //     </Stack>
  //   );
  // }

  return (
    <div>
      <Header
        teams={teams}
        teamIsLoading={teamIsLoading}
        groupingUserFromRedux={groupingUserFromRedux}
      />
      <GroupingBoards />
    </div>
  );
});

export default AllocationGrouping;
